import styled from "styled-components/macro";
import { Button } from "antd";

export const SocialAuthButton = styled(Button)`
  & {
    border-color: ${({ theme }) => theme.colors.borderSecondary};
    line-height: 56px;
    color: ${({ theme }) => theme.colors.hardGray};
    font-weight: ${({ theme }) => theme.font.weightMedium};
    height: 56px;
    padding: 0 1rem;
    box-shadow: none;

    img {
      vertical-align: text-bottom;
    }
  }
`;

export const SocialAuthWrapper = styled.div<{ $m?: string | 0 }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin: ${({ $m }) => $m || 0};
  ${SocialAuthButton} {
    &.socialAuthButton {
      &:focus-visible {
        outline: 0 none transparent;
        outline-offset: 0;
      }
      &:hover,
      &:active {
        color: ${({ theme }) => theme.colors.hardGray};
        border-color: ${({ theme }) => theme.colors.borderSecondary};
      }
    }
  }
`;
